import { Entity, HexColor, Location } from '@nx-smartmonkey/shared/domain';
import { removeEmpty } from '@nx-smartmonkey/shared/helpers';

export type FuelTypes = `diesel` | `gasoline` | `electric`;

export const fuelConsumptionUnitsMap: Record<FuelTypes, string> = {
  electric: `kWh/100km`,
  diesel: `l/100km`,
  gasoline: `l/100km`,
} as const;

interface VehicleProps {
  organization_id: string;
  project_id: string;
  external_id?: string;
  label?: string;
  phone?: string;
  email?: string;
  fuel_type?: FuelTypes;
  consumption?: number;
  color?: HexColor;
  comments?: string;
  default_start_location?: Location;
  default_end_location?: Location;
  default_time_window?: [number, number];
  updated_at?: Date;
}

export interface VehicleUpdateProps {
  label?: string;
  email?: string;
  fuel_type?: FuelTypes;
  consumption?: number;
  default_time_window?: [number, number];
  default_start_location?: Location;
  default_end_location?: Location;
}

export class Vehicle extends Entity<VehicleProps> {
  get id(): string {
    return this._id!;
  }
  get organization_id(): string | undefined {
    return this.props.organization_id;
  }
  get project_id(): string | undefined {
    return this.props.project_id;
  }
  get external_id(): string | undefined {
    return this.props.external_id;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  set label(label: string | undefined) {
    this.props.label = label;
  }
  get phone(): string | undefined {
    return this.props.phone;
  }
  get email(): string | undefined {
    return this.props.email;
  }
  set email(email: string | undefined) {
    this.props.email = email;
  }
  get fuel_type(): FuelTypes | undefined {
    return this.props.fuel_type;
  }
  set fuel_type(fuel_type: FuelTypes | undefined) {
    this.props.fuel_type = fuel_type;
  }
  get consumption(): number | undefined {
    return this.props.consumption;
  }
  set consumption(consumption: number | undefined) {
    this.props.consumption = consumption;
  }
  get default_time_window(): [number, number] | undefined {
    return this.props.default_time_window;
  }
  set default_time_window(default_time_window: [number, number] | undefined) {
    this.props.default_time_window = default_time_window;
  }
  get color(): HexColor | undefined {
    return this.props.color;
  }
  get comments(): string | undefined {
    return this.props.comments;
  }
  get default_start_location(): Location | undefined {
    return this.props.default_start_location;
  }
  set default_start_location(default_start_location: Location | undefined) {
    this.props.default_start_location = default_start_location;
  }
  get default_end_location(): Location | undefined {
    return this.props.default_end_location;
  }
  set default_end_location(default_end_location: Location | undefined) {
    this.props.default_end_location = default_end_location;
  }

  get updated_at(): Date | undefined {
    return this.props.updated_at;
  }

  private constructor(props: VehicleProps, id: string) {
    super(props, id);
  }

  static create(props: VehicleProps, id: string): Vehicle {
    return new Vehicle(props, id);
  }

  update(props: VehicleUpdateProps) {
    removeEmpty(props);

    if (props.label !== undefined) this.props.label = props.label;
    if (props.email !== undefined) this.props.email = props.email;
    if (props.fuel_type !== undefined) this.props.fuel_type = props.fuel_type;
    if (props.consumption !== undefined) this.props.consumption = props.consumption;
    if (props.default_time_window !== undefined) this.props.default_time_window = props.default_time_window;
    if (props.default_start_location !== undefined) this.props.default_start_location = props.default_start_location;
    if (props.default_end_location !== undefined) this.props.default_end_location = props.default_end_location;
    this.props.updated_at = new Date();
  }
}
